export default __webpack_public_path__ + "rotterdam-503084a50ce19aa6d18f770f8ae022e5.bundle.jpg";